import { z } from 'zod';
import { msg, issue } from '@/lib/forms/messages';
import { requiredScoreRange1to10, scoreRange1to10 } from '@/lib/forms/primitives';

// Not a createSchema(t) factory: msg() resolves lazily at parse time, so one schema serves both locales.

// api/routes/drbfm.py:243-245 all Field(None, ge=1, le=10); 017_drbfm_tables.sql:62,69
// severity NOT NULL + CHECK 1..10; 040_drbfm_content_review.sql:21-22,87-90
// occurrence/detection nullable, CHECK (IS NULL OR BETWEEN 1 AND 10).

export const failureModeReviewSchema = z
  .object({
    // Required-ness mirrors the card's submit gate (contentIncomplete), not the columns —
    // cause/effect are nullable TEXT (017_drbfm_tables.sql:58-60). No length caps:
    // all three columns are TEXT with no CHECK, so a cap would be an invented limit.
    failureDescription: z.string().trim().min(1, msg('validation.required')),
    failureCause: z.string().trim().min(1, msg('validation.required')),
    failureEffect: z.string().trim().min(1, msg('validation.required')),

    severityScore: scoreRange1to10,
    occurrenceScore: scoreRange1to10.optional(),
    detectionScore: scoreRange1to10.optional(),

    countermeasureRequirement: z.enum(['pending', 'required', 'not_required']),
    countermeasureNotRequiredReason: z.string(),
  })
  .superRefine((value, ctx) => {
    if (
      value.countermeasureRequirement === 'not_required'
      && !value.countermeasureNotRequiredReason.trim()
    ) {
      ctx.addIssue(issue('validation.required', ['countermeasureNotRequiredReason']));
    }
  });

/**
 * The S/O/D confirmation gate: the same object, but O and D are required for THIS
 * action (api/routes/drbfm.py scores the mode only with all three). `.safeExtend`,
 * not `.extend` — the base carries a superRefine and `.extend` refuses to override
 * keys on a refined schema.
 */
export const failureModeScoreConfirmSchema = failureModeReviewSchema.safeExtend({
  occurrenceScore: requiredScoreRange1to10,
  detectionScore: requiredScoreRange1to10,
});
